<template>
    <el-container>
        <fhead></fhead>
        <el-main >
            <el-breadcrumb class="center" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">{{$t('l.home')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{$t('l.fhead.peers')}}</el-breadcrumb-item>
            </el-breadcrumb>
            <el-card class="box-card center" style="margin-top: 16px">
                <div slot="header" class="clearfix">
                    <span>{{$t('l.fhead.peers')}} <span style="color: rgb(144, 147, 153);">（{{$t('l.peers.txt1')}}：{{peers.length}}，{{$t('l.peers.txt2')}} ）</span></span>
                </div>
                <el-table class="center"
                          v-loading="peersLoading"
                          stripe
                          :data="peers"
                          style="width: 100%">
                    <el-table-column
                            label="id"
                            width="60">
                        <template slot-scope="scope">
                            {{scope.$index+1}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="address"
                            :label="$t('l.peers.address')"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="version"
                            :label="$t('l.peers.version')"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="platform"
                            :label="$t('l.peers.platform')"
                            width="280">
                    </el-table-column>
                    <el-table-column
                            :label="$t('l.peers.services')"
                            width="320">
                        <template slot-scope="scope">
                            {{scope.row.services.toString()}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            :label="$t('l.peers.lastUpdated')">
                        <template slot-scope="scope">
                            {{$g.wallet.formatDateTime(scope.row.lastUpdated,($store.state.epochBeginning-500))}}
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </el-main>
        <el-footer class="footer">
            COPYRIGHT © 2018. ALL RIGHTS RESERVED. DESIGNED BY
            <a target="_blank" href="https://hebeblock.com/">HEBEBLOCK</a>
        </el-footer>
    </el-container>
</template>


<script>
    import fhead from '../fhead.vue';

    export default {
        name: 'peers',
        components: {
            fhead
        },
        data () {
            return {
                peersLoading:true,
                peers:[],
            }
        },
        created: function () {
            this.$ajax({
                method: 'get',
                url: 'requestType=getPeers&active=true&includePeerInfo=true'
            }).then(response => {
                this.peersLoading=false;
                this.peers=response.peers
            });
        }
    }
</script>


<style scoped>
</style>  


// WEBPACK FOOTER //
// src/components/peer/peers.vue